import logoFull from "@/shared/assets/logo/logo-full.svg";

export type RGBTuple = [number, number, number];

export const BRAND_GREEN: RGBTuple = [0, 136, 86];
export const TEXT_PRIMARY: RGBTuple = [28, 25, 23];
export const TEXT_SECONDARY: RGBTuple = [120, 113, 108];
export const BORDER_COLOR: RGBTuple = [214, 211, 209];

export function loadLogoAsDataUrl(): Promise<string> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext("2d")!;
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = () => resolve("");
    img.src = logoFull;
  });
}
